import type { Language } from '@/types';
export const initLanguage = (
  storedLanguage: Language | undefined,
  i18n: ReturnType<typeof useI18n> = {}
) => {
  if (storedLanguage) {
    i18n.setLocale(storedLanguage);
    return;
  }

  const browserLanguage = navigator.language.split('-')[0];
  const languages = Object.keys(i18n.messages.value);
  const isSupportingBrowserLanguage = languages.some(
    (language) => language === browserLanguage
  );
  if (browserLanguage && isSupportingBrowserLanguage) {
    i18n.setLocale(browserLanguage as 'en' | 'de');
    return;
  }
  i18n.setLocale('en');
};
